import config from "./config";

const directory = config.jigsawpuzzle.directory;
const jigsawpuzzles = [
    {
        category: "FE_L1_1",
        link: `${config.flashUrl}/${directory}/FE_L1_1`,
        target: true
    },
    {
        category: "FE_L1_D2",
        link: `${config.flashUrl}/${directory}/FE_L1_D2`,
        target: true
    },
    {
        category: "FE_L2_D1",
        link: `${config.flashUrl}/${directory}/FE_L2_D1`,
        target: true
    },
    {
        category: "FE_L2_D2",
        link: `${config.flashUrl}/${directory}/FE_L2_D2`,
        target: true
    },
    {
        category: "FE_L4_L1",
        link: `${config.flashUrl}/${directory}/FE_L4_L1`,
        target: true
    },
    {
        category: "Normal vs Easy",
        link: `${config.flashUrl}/${directory}/Jigsaw_Puzzle_NormalVSEasy`,
        target: true
    }
];

export default jigsawpuzzles;
